/**
 * Guide des tailles — volets + sommaire + ancres
 * Accordéons fermés par défaut (classes is-closed en Liquid).
 */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    var roots = document.querySelectorAll('[data-guide-tailles]');
    roots.forEach(initGuide);
  });

  function initGuide(root) {
    function setVolet(host, open) {
      var btn = host.querySelector('.volet-btn, .toc__toggle');
      host.classList.toggle('is-open', open);
      host.classList.toggle('is-closed', !open);
      if (btn) btn.setAttribute('aria-expanded', String(open));
    }

    root.querySelectorAll('.volet-btn, .toc__toggle').forEach(function (btn) {
      var host = btn.closest('.gamme, .situation, .coupe, .toc');
      if (!host) return;
      btn.addEventListener('click', function () {
        setVolet(host, !host.classList.contains('is-open'));
      });
    });

    root.querySelectorAll('.toc a, .quick__list a').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var href = a.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;
        var t = root.querySelector(href) || document.querySelector(href);
        if (!t) return;
        e.preventDefault();

        var host = t.closest('.gamme, .situation, .coupe');
        if (host && host.classList.contains('is-closed')) setVolet(host, true);
        if (t.classList.contains('is-closed') && (t.classList.contains('gamme') || t.classList.contains('situation') || t.classList.contains('coupe'))) {
          setVolet(t, true);
        }

        var top = t.getBoundingClientRect().top + window.scrollY - 24;
        window.scrollTo({ top: top, behavior: 'smooth' });
        updateToc();
      });
    });

    var links = Array.prototype.slice.call(root.querySelectorAll('.toc a'));
    var targets = links.map(function (a) {
      var href = a.getAttribute('href');
      return href ? document.querySelector(href) : null;
    });

    function updateToc() {
      var y = window.scrollY + 150;
      var best = -1;
      targets.forEach(function (t, i) {
        if (!t) return;
        var top = t.getBoundingClientRect().top + window.scrollY;
        if (top <= y) best = i;
      });
      links.forEach(function (a, i) {
        if (i === best) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
      });
    }

    window.addEventListener('scroll', updateToc, { passive: true });
    window.addEventListener('resize', updateToc);
    updateToc();
  }
})();
